import { Box, Button, Typography } from "@mui/material";
import BackIcon from "assets/icons/dark-back.svg";
import { businessListStyles } from "styles/BusinessListDirectory/listHeader.styles";

interface ListHeaderProps {
  isBackOnly?: boolean;
  onBackPress?: any;
  headerBtnAction: () => void;
  headerTitle: string;
  headerHeadline: string;
  btnTitle: string;
}

const ListHeader = ({
  isBackOnly = false,
  onBackPress,
  headerBtnAction,
  headerTitle,
  headerHeadline,
  btnTitle,
}: ListHeaderProps) => {
  return (
    <>
      {isBackOnly ? (
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            cursor: "pointer",
            width: "fit-content",
          }}
          onClick={onBackPress}
        >
          <img src={BackIcon} alt="back-icon" />
          <Typography>Back</Typography>
        </Box>
      ) : (
        <Box sx={businessListStyles.headerContainer}>
          <Box>
            <Typography sx={businessListStyles.headerTitle}>
              {headerTitle}
            </Typography>

            <Typography sx={businessListStyles.underlineHeading}>
              {headerHeadline}
            </Typography>
          </Box>
          <Button
            variant="contained"
            sx={businessListStyles.btnStyle}
            onClick={headerBtnAction}
          >
            {btnTitle}
          </Button>
        </Box>
      )}
    </>
  );
};

export default ListHeader;
